import { Button, Dialog, FormGroup, IDialogProps } from '@blueprintjs/core'
import * as React from 'react'
import Client from '../../../client'
import TagSelector from './TagSelector'
import Errors from '../../../components/Errors'

interface Props {
  productId: number
  onClose: (updatedTags: string[]) => void
  tags: []
}

class TagEditorDialog extends React.Component<Props & IDialogProps> {
  state = { loading: false, tags: this.props.tags, errors: null }

  updateTags = async () => {
    this.setState({ loading: true, errors: null })

    try {
      await Client.updateProductV4(this.props.productId, { tags: this.state.tags })
      // fetch the full, canonical product after updating tags so callers
      // receive the complete product payload and can sync parent state.
      const fresh = await Client.getProductV6(this.props.productId)
      this.setState({ loading: false }, () => {
        this.props.onClose(fresh.data)
      })
    } catch (e) {
      this.setState({ loading: false, errors: e.response?.data || e.message })
    }
  }

  render() {
    return (
      <Dialog title="Edit tags" {...this.props}>
        <div className="bp3-dialog-body">
          <Errors error={this.state.errors} />

          <FormGroup label="Manage tags">
            <TagSelector
              value={this.state.tags}
              onChange={v => {
                this.setState({ tags: v })
              }}
            />
          </FormGroup>
        </div>
        <div className="bp3-dialog-footer">
          <div className="bp3-dialog-footer-actions">
            <Button minimal onClick={this.props.onClose}>
              Cancel
            </Button>
            <Button onClick={this.updateTags} intent="primary" loading={this.state.loading}>
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    )
  }
}

export default TagEditorDialog
